import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import WizardLauncher from './WizardLauncher';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <img src="/media/logos/Unilearn_wb.png" alt="UniLearn - Moodle Cloud Services" />
            </Link>
          </div>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li><a href="/#inicio" onClick={() => setIsMenuOpen(false)}>Inicio</a></li>
              <li><a href="/#servicios" onClick={() => setIsMenuOpen(false)}>Servicios</a></li>
              <li><Link to="/administracion-moodle" onClick={() => setIsMenuOpen(false)}>Administración</Link></li>
              <li><a href="/#precios" onClick={() => setIsMenuOpen(false)}>Precios</a></li>
              <li><a href="/#contacto" onClick={() => setIsMenuOpen(false)}>Contacto</a></li>
              <li className="nav-cta">
                <a href="/#contacto" className="btn-free-trial-mobile" onClick={() => setIsMenuOpen(false)}>
                  Comenzar Ahora
                </a>
              </li>
            </ul>
          </nav>

          <div className="header-wizard">
            <WizardLauncher />
          </div>

          <button 
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;